import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./utils/Pixel";

export default function PixelTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
